package com.daytimegaming.ourdailyfinances.web

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.daytimegaming.ourdailyfinances.App
import com.daytimegaming.ourdailyfinances.di.initKoin
import com.daytimegaming.ourdailyfinances.domain.plaid.PlaidEventBus
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.analytics.analytics
import kotlinx.browser.window
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import org.koin.core.context.GlobalContext

@OptIn(ExperimentalComposeUiApi::class, DelicateCoroutinesApi::class)
fun main() {
    initKoin()

    Firebase.analytics.setAnalyticsCollectionEnabled(true)

    val isSystemDark = try {
        window.matchMedia("(prefers-color-scheme: dark)").matches
    } catch (e: Exception) {
        false
    }

    val plaidEventBus = GlobalContext.get().get<PlaidEventBus>()

    ComposeViewport {
        App(
            darkTheme = isSystemDark,
            dynamicColor = false,
            onPlaidTokenReady = { linkToken ->
                val plaid = js("Plaid")
                val options = js("{}")
                options.token = linkToken
                options.onSuccess = { publicToken: String, metadata: dynamic ->
                    val institutionName = metadata.institution?.name as? String
                    GlobalScope.launch {
                        plaidEventBus.accountLinked(publicToken, institutionName)
                    }
                }
                options.onExit = { err: dynamic, metadata: dynamic ->
                    // Handle user exit/cancellation
                }
                val handler = plaid.create(options)
                handler.open()
            }
        )
    }
}
